import { render, staticRenderFns } from "./CreateMaterial.vue?vue&type=template&id=8106bc1e"
import script from "./CreateMaterial.vue?vue&type=script&lang=js"
export * from "./CreateMaterial.vue?vue&type=script&lang=js"
import style0 from "./CreateMaterial.vue?vue&type=style&index=0&id=8106bc1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports